// extracted by mini-css-extract-plugin
export default {"category":"_315VQlBFEqqFuPCZkD4NUt","link":"_1ozy9zc0HJQlGhQDDQ0k2h","header":"_1sAPK4jpN1UCpCFY_bFNAn"};